











import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
  Mutation,
} from 'vuex-class';
import Transformation from '@/classes/transformation';

@Component({
  components: {
  },
})
export default class FlowEditor extends Vue {

  @Getter private activeOrganisation: any;
  @Getter private login: any;

  private getOrgNRSubdomain() {
    return Transformation.hashOrgSlug(this.activeOrganisation[0].slug);
  }

  private get getNRUrl() {
    const orgSlug = this.getOrgNRSubdomain();
    const token = this.login.token;
    return `https://${orgSlug}.daizy.io/auth/strategy/?token=${token}`;
  }
}
